import { Typography, TypographyType } from './typography';
import { Spacing, SpacingDirection, SpacingSize } from './spacing';
import styles from './look-forward-text.module.scss';

/**
 * Look forward text
 */
export const LookForwardText = () => {
  return (
    <Spacing size={SpacingSize.medium} direction={SpacingDirection.vertical} className={styles.lookForward}>
      <Typography type={TypographyType.h2} className={styles.title}>
        Будем рады видеть
        <br />
        тебя в команде
      </Typography>

      <Typography type={TypographyType.large}>
        Мы ценим твое время и искренне надеемся, что наше предложение станет для тебя значимым шагом.
      </Typography>

      <Typography type={TypographyType.large}>
        Все условия данного предложения будут детально прописаны и закреплены в трудовом договоре.
      </Typography>

      <Typography type={TypographyType.large}>Если у тебя остались вопросы — свяжись с нами.</Typography>

      <Typography type={TypographyType.large}>Ждём решения, чтобы продолжить этот путь вместе!</Typography>
    </Spacing>
  );
};
